export default __webpack_public_path__ + "static/media/leadership.42dc60a5.svg";